<template>
    <div class="text-center py-16">

        <h1 class="text-5xl mb-8" style="line-height:1.2em;">Not Supported Yet</h1>

        <h2 class="text-3xl mb-8">{{ vastate }}</h2>

        <a
            class="nectar-button large regular-button accent-color has-icon cursor-pointer"
            data-color-override="false"
            data-hover-color-override="false"
            @click="$router.go(-1)"
            style="visibility: visible;"
        >
            <span>Back </span><i class="icon-button-arrow"></i>
        </a>

    </div>
</template>

<script>

import { mapState } from 'vuex'

export default {

    name: 'VaNope',

    computed: {
        ...mapState(['vastate'])
    }

}
</script>
